import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseComponentWithDialog } from "../../../../base-admin-panel/base-component-with-dialog";
import { ImageWithDescriptionModel, ObjectPhotosService } from "../../../../../../services/objectphotos.service";
import { ObjectPhotoDialog } from "../object-photo-dialog/object-photo-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { AccessRights } from 'app/services/users.service';

@Component({
  selector: 'app-object-photos',
  templateUrl: './object-photos.component.html',
  styleUrls: ['./object-photos.component.css'],
  standalone: false
})
export class ObjectPhotosComponent extends BaseComponentWithDialog implements OnInit {
  @Input()
  Id: number;

  @Input()
  readonly: boolean = false;

  Objects: ImageWithDescriptionModel[] = [];
  protected translate: TranslateService;

  private service: ObjectPhotosService;
  public canEditTrackers: boolean = false;
  constructor(protected injector: Injector) {
    super(injector);
    this.service = injector.get(ObjectPhotosService);
    this.translate = injector.get(TranslateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.Update();
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }
  protected Update() {
    this.Objects = [];
    this.service.get(this.Id).subscribe(objects => {
      this.Objects = objects;
    });
  }

  public onAddClick() {
    const model = new ImageWithDescriptionModel();
    model.ObjectId = this.Id;

    this.prepareModal(ObjectPhotoDialog);
    this.componentRef.instance.onSubmit.subscribe(() => {
      this.service.update(model).subscribe(() => {
        this.Update();
        this.componentRef.instance.close();
      });
    });
    this.componentRef.instance.open(model);
  }

  public onEditClick(object: ImageWithDescriptionModel) {
    this.prepareModal(ObjectPhotoDialog);
    this.componentRef.instance.onSubmit.subscribe(() => {
      this.service.update(object).subscribe(() => {
        this.Update();
        this.componentRef.instance.close();
      });
    });
    this.componentRef.instance.open(object);
  }

  public onDeleteClick(object: ImageWithDescriptionModel) {
    if (!confirm(this.translate.instant("Delete") + "?"))
      return;

    this.service.delete(object.Id).subscribe(() => {
      this.Update();
    });
  }

}
